import { Button, Input, MagellanPopup } from 'components/atoms';
import CopyrightSelectCard from 'components/molecules/card/copyright-select/CopyrightSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useGetCopyrightList } from 'services/account';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface ICopyrightPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectCopyright?: (copyright: string | null, actions: PopupActions) => void;
  open?: boolean;
  initialCopyright?: string | null;
  displayMode?: boolean;
  mode: 'pline' | 'cline';
}

const CopyrightPopupForm = ({
  trigger,
  onSelectCopyright,
  open,
  initialCopyright = null,
  displayMode,
  mode,
}: ICopyrightPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [selectedCopyright, setSelectedCopyright] = useState<string | null>(null);

  const copyrights = useGetCopyrightList();

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={displayMode === false ? false : open}
      onOpen={() => {
        setSelectedCopyright(initialCopyright);
      }}
      onClose={() => {
        setSelectedCopyright(null);
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t(`input.label.${mode}`)}</MagellanPopup.Header>
        <p className="font-semibold opacity-65">{t('music-product-digital.copyrights.type-own')}</p>
        <Input.Text
          value={selectedCopyright ?? ''}
          onChange={(e) => setSelectedCopyright(e.target.value)}
          name=""
          appBackground
        />
        <p className="font-semibold opacity-65">
          {t('music-product-digital.copyrights.select-existing')}
        </p>
        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none] gap-2">
          {copyrights.data?.map((c, i) => (
            <CopyrightSelectCard
            key={i}
              copyright={c.value}
              isSelected={selectedCopyright === c.value}
              onClick={(newCopyright) => {
                setSelectedCopyright((prev) => (prev === newCopyright ? null : newCopyright));
              }}
            />
          ))}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current &&
              onSelectCopyright &&
              onSelectCopyright(selectedCopyright, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default CopyrightPopupForm;
